// This should only be used within the main app instance
import { app } from '../../../entrypoints/main.js'
// References the VueToasted instance bound to the current vue instance
// This is a helper function for toasts. This can be used within Vuex and/or any place outside of the component template or instance.
// Usage example: appToasted().success('Success message...')
export const appToasted = () => {
  return app.config.globalProperties.$toasted
}
